// Die Adressen im Dashboard, die mehr als eine Seite baut.

import { bereichVon } from './bereiche'
import type { BereichId, ImportLaufKurz } from './typen'

/** Wo ein Lauf angesehen wird: ein Excel-Import hat keinen Positionslauf, sondern einen Plan mit eigener Seite. */
export function laufPfad(lauf: Pick<ImportLaufKurz, 'id' | 'dokumenttyp'>): string {
  return lauf.dokumenttyp === 'excel' ? `/importe/excel/${lauf.id}` : `/importe/${lauf.id}`
}

/** Der Assistent eines Bereichs mit einer Frage im Gepäck - Hinweise, Fällig-Liste, Kopfzeile, Heute nutzen ihn. */
export function assistentPfad(frage: string, bereich: BereichId = 'verpackung'): string {
  return `${bereichVon(bereich).praefix}/assistent?frage=${encodeURIComponent(frage)}`
}

/** Ein bestimmtes Gespräch im Assistenten öffnen - „Heute" verlinkt so auf liegen gebliebene Fäden. */
export function gespraechPfad(unterhaltungId: number, bereich: BereichId = 'verpackung'): string {
  return `${bereichVon(bereich).praefix}/assistent?unterhaltung=${unterhaltungId}`
}

/** Ein Artikel in den Stammdaten - die Liste dort ist auf seine Nummer gefiltert. */
export function artikelPfad(artikelnummer: string): string {
  return `/stammdaten?suche=${encodeURIComponent(artikelnummer)}`
}

/** Ein Lauf der Rohstoffnotierungen. */
export function notierungLaufPfad(id: number): string {
  return `/notierungen/importe/${id}`
}

/** Was die Tabelle hervorhebt: eine Spalte und die Zeilen dieser Liefermonate (Monatserste). */
export interface NotierungAuswahl {
  spalte: number
  monate: string[]
}

/** Das Blatt einer Gruppe, auf Wunsch zu einem Stichtag und mit einer hervorgehobenen Spalte. */
export function notierungTabellePfad(gruppe: string, am?: string, auswahl?: NotierungAuswahl): string {
  // Von Hand statt URLSearchParams: die Monate bleiben mit Komma lesbar („monate=2026-11-01,2026-12-01“).
  const teile = [am && `am=${am}`, auswahl && `spalte=${auswahl.spalte}`, auswahl?.monate.length && `monate=${auswahl.monate.join(',')}`]
  const suche = teile.filter(Boolean).join('&')
  return `/notierungen/tabelle/${encodeURIComponent(gruppe)}${suche ? `?${suche}` : ''}`
}

/** Die Zuordnungsregeln, auf Wunsch gefiltert auf einen Lieferanten, eine Spalte oder eine Regel. */
export function notierungRegelnPfad(filter: { lieferant?: number; quelle?: number; regel?: number } = {}): string {
  const suche = Object.entries(filter)
    .filter(([, wert]) => wert !== undefined)
    .map(([name, wert]) => `${name}=${wert}`)
    .join('&')
  return `/notierungen/stammdaten/regeln${suche ? `?${suche}` : ''}`
}

/** Der Verlauf eines Rohstoffs für einen Liefermonat. */
export function notierungVerlaufPfad(rohstoffId: number, liefermonat?: string): string {
  // Ein Liefermonat (Monatserster) ist der Monatszeitraum „2026-09“.
  return `/notierungen/verlauf?rohstoff=${rohstoffId}${liefermonat ? `&zeitraum=${liefermonat.slice(0, 7)}` : ''}`
}
